import { BaseFetch } from "../main-model"
export default class CurriculumModel extends BaseFetch {
    getCurriculumBy = (data) =>
    this.authFetch({
      url: "curriculum/getCurriculumBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getCurriculumById = (data) =>
    this.authFetch({
      url: "curriculum/getCurriculumById",
      method: "POST",
      body: JSON.stringify(data),
    })
    getCurriculumByYearClassID = (data) =>
    this.authFetch({
      url: "curriculum/getCurriculumByYearClassID",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateCurriculumById = (data) =>
    this.authFetch({
      url: "curriculum/updateCurriculumById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertCurriculum = (data) =>
    this.authFetch({
      url: "curriculum/insertCurriculum",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteCurriculumById = (data) =>
    this.authFetch({
      url: "curriculum/deleteCurriculumById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertCurriculumSchoolBudget = (data) =>
    this.authFetch({
      url: "curriculum/insertCurriculumSchoolBudget",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateCurriculumSchoolBudgetById = (data) =>
    this.authFetch({
      url: "curriculum/updateCurriculumSchoolBudgetById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteCurriculumSchoolBudgetById = (data) =>
    this.authFetch({
      url: "curriculum/deleteCurriculumSchoolBudgetById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
